export default __webpack_public_path__ + "static/media/PXL_20220410_082218109.PORTRAIT_edited (2).52212bc5.jpeg";